import styled, { FlattenSimpleInterpolation, keyframes } from "styled-components";

export const fade = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

interface IFadedDiv{
  alignItems?: "center" | "flex-start" | "flex-end";
  styleInline?: string | FlattenSimpleInterpolation; 
}

const FadedDiv = styled.div<IFadedDiv>`
  animation: ${fade} 500ms ease;
  display: flex;
  width: 100%;
  flex-direction: column;
  ${(props) => props.alignItems && `align-items: ${props.alignItems};`}
  ${(props) => props.styleInline && props.styleInline}
`;

export default FadedDiv;
